// extracted by mini-css-extract-plugin
export default {"common_view":"styles_common_view__NcAas","view_header":"styles_view_header__JhceD"};